<template>
    <b-container>
        <b-card>
          <b-card-header>
          <h4>{{(logOutText===null)?'Successfully':'You have been'}} Logged Out</h4></b-card-header>

        <b-alert show variant="warning" v-if="logOutText!==null">{{logOutText}}</b-alert>
        <h4><router-link :to="{name: 'login'}">Log back in <font-awesome-icon icon='sign-in-alt'/></router-link></h4>
          <b-card-footer
            align="center"
          >
          <a href="/privacy" class="card-link">Privacy Policy</a>
          </b-card-footer>
        </b-card>
    </b-container>
</template>
<script>
export default {
  name: 'LogOut',
  props: {
      logOutText:{
          type: String,
          required: false,
          default: null
      }
  },
  mounted() {
      console.log(`Good Bye! ${this.$store.state.user.full_name}`);
      this.$store.commit('user/clearUser');
      this.$store.commit('ward/clearOrgFilter');
  },
}
</script>
